import { observable, action, computed } from 'mobx';
import { eSignChinaService} from '@/store/services/index';
import * as APP_CONSTANTS from 'Constants/app.constant';
import store from 'Store/index';
import intl from 'react-intl-universal';
import {  baseUrlApis } from 'Api/index'

export default class EsignCnStore {

    @observable esignDoc = null;

    @observable signaturesInfo = null;

    @observable eSignCN_ActiveFieldList = null

    @observable eSignCN_TotalActiveFieldList = []

    @observable signIdList = null;

    @observable initSignFieldsColor = [];

    @observable flowSignFormStatus = 0;

    @observable outSignPersonInfo = null;

    @observable outSignOrgInfo = null;

    @observable currentSignerSubject = ''; // out_org , out_person , in

    @observable outSignSubscriptionCheckRes = null;

    @observable surveyVisible = false;

    @observable auditTrailData = {}

    outSignStampList = []

    oustSignStampListOfCanUse = []

    innerSignStampList = [];

    authPluginCaches = {};

    @computed get isInnerDoc() {
        return this.signaturesInfo && this.signaturesInfo.auth && !!this.signaturesInfo.auth[0].SAMLResponse
      }

    // @computed get signaturesInfo_inner(){
    //     if(this.signaturesInfo){
    //         const auth_inner = this.signaturesInfo.auth.filter(item=>item.method == 'SAML');
    //         let obj ={...this.signaturesInfo,auth:auth_inner};
    //         return obj
    //     }else{
    //         return null
    //     }
    //     }
    @action setDoc = (doc)=>{
        this.esignDoc = doc
    }

    @action setSignaturesInfo =(info)=>{
        this.signaturesInfo = info;
    }
    @action ValidateSAMLResponseAllInfo = (parm)=>{
        return eSignChinaService.ValidateSAMLResponseAllInfo(parm)
    }

    @action updateESignCN_ActiveFieldList(list) {
        this.eSignCN_ActiveFieldList = list
    }

    @action updateESignCN_TotalActiveFieldList(list) {
        this.eSignCN_TotalActiveFieldList = list
    }

    @action cleanActiveFieldList () {
        this.eSignCN_ActiveFieldList = null
    }

    @action cleanTotalFieldList () {
        this.eSignCN_TotalActiveFieldList = []
    }

    @action setSignIdList = (list)=>{
        this.signIdList = list;
    }

    @action getEvidenceListForESign = (ids, callback)=>{
        return eSignChinaService.getEvidenceListForESign(ids, callback)
    }

    @action updateInitSignFieldsColor = (item, type = "ADD")=>{
        if (type === "ADD") {
            this.initSignFieldsColor.push(item)
        } else {
            if (this.initSignFieldsColor.length > 0) {
                const index = this.initSignFieldsColor.findIndex(tip => tip.id === item.id);
                index > -1 && this.initSignFieldsColor.splice(index, 1)
            }
        }
    }

    @action cleanInitSignFieldsColor = ()=>{
        this.initSignFieldsColor.length = 0
    }
    @action updateValueOfFlowSignFormStatus = (val)=>{
        this.flowSignFormStatus = val;
    }

    @action async fetchOutSignUserInfo(person, orgList) {
        /**
         * 因为authPlugin的引入，做了如下调整，以减少接口请求和优化数据加载
         * 1，如果传入，设置后直接返回
         * 2，如果有缓存，直接返回
         * 3，请求接口数据（插件存在的情况下，不会用到此项）
         */

        if (person) {
            this.outSignPersonInfo = person;
            if (orgList && orgList[0]) {
                this.outSignOrgInfo = orgList;
            }
            return;
        }

        if (this.outSignOrgInfo && this.outSignPersonInfo) {
            return;
        }

        const res = await eSignChinaService.verifyUserInformation();
        if (res.stat !== 0) {
            if (res.error !== "OUT_SIGN_SUBSCRIPTION_ERROR") {
                eSignChinaService.signProcessMessage('error', intl.formatMessage({ id: 'eSignChinaUnite.gallery.fetchUserInfoError' }));
            }
            return Promise.reject({stat: res.stat, msg: "OUT_SIGN_SUBSCRIPTION_ERROR"});
        }
        person = res.data.person;
        orgList = res.data.orgList;

        this.outSignPersonInfo = person;
        this.outSignOrgInfo = orgList;
    }

    @action updateOutSignStampList(stampList) {
        this.outSignStampList = stampList;
        this.oustSignStampListOfCanUse = stampList.filter(stamp => !stamp.isOrg || stamp.usePermission)
        store.appStore.emitEvent(APP_CONSTANTS.EVENT_UPDATE_OUT_STAMPS)
    }
    @action async gotoSignPC (processId){
        const enterpriseId = store.userStore && store.userStore.roleInfo && store.userStore.roleInfo.enterpriseId;
        let config = await baseUrlApis.loadUrlConfig()
        let link = config.newEsignCNpc ;
        let url = enterpriseId?`${link}?id=${processId}&enterpriseId=${enterpriseId}`:`${link}?id=${processId}`;
        store.userStore.doGetTicket(link,(ticket)=>{
          window.open(`${url}&ticket=${ticket}`);
        })
    }

    @action updateCurrentSignerSubject(val) {
        this.currentSignerSubject = val;
    }
    @action updateOutSignSubscriptionCheckRes(res) {
        this.outSignSubscriptionCheckRes = res;
    }
    @action updateESignCNSurveyVisible(bool) {
        this.surveyVisible = bool;
    }
    @action updateAuditTrailData(docHash, data) {
        this.auditTrailData[docHash] = data;
    }
    @action getAuditTrailData(docHash) {
        return this.auditTrailData[docHash];
    }


    @action setAuthPluginCaches(url, res = true) {
        this.authPluginCaches[url] = res;
    }

    @action getAuthPluginCaches(url) {
        return !!this.authPluginCaches[url];
    }

    @action setInnerStampList(list) {
        this.innerSignStampList = list || [];
    }

    @action getInnerStampList() {
        return this.innerSignStampList || []
    }
}
